import { useGlobalToast } from '@centric-os/components/src/core/messages/toast';

export default () => {
  const { showSuccessToast } = useGlobalToast();

  /**
   * Copy a string value to the clipboard and optionally display a toast success message
   * @param value The string value to copy to the clipboard
   * @param toastMessage Optional toast message to display after copying to the clipboard. If undefined, no toast will be displayed.
   */
  const copyToClipboard = (value: string, toastMessage?: string): void => {
    navigator.clipboard.writeText(value);
    if (toastMessage) {
      showSuccessToast(toastMessage);
    }
  };

  return { copyToClipboard };
};
